import { z } from "zod";

export const containerTypeSelectOptionSchema = z.object({
	isoTypeCode: z.string(),
	teu: z.number(),
});
